/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/sapphicspace/"

const SAPPHICSPACE: CommunityData = {
  code: "sapphicspace",
  inviteCode: "sapphicspace",
  name: "Sapphic Space",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sapp-358`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#5b1ae4",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[160px] h-[86px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[86px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#d8c7fb",
      asideBg: "#d8c7fb",
      asideStyles: "border-r border-[#5b1ae433]",
      contentBg: "#d8c7fb",
      contentBoxShadow: "!rounded-3xl ",
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      mainFont: "font-['FigtreeRegular']",
      primaryButton:
        "bg-[#5b1ae4] border-2 border-[#5b1ae4] rounded-lg px-[18px] py-[18px] !text-[#ffffff] font-['PottaOneRegular'] !text-[16px] uppercase text-left leading-[120%]",
    },
    navigation: {
      iconsColor: "#5b1ae4",
      sideBarSeparator: "border-r-[1px] border-[#5b1ae433]",
      separator: "border-[#5b1ae433]",
      item: "font-['InterRegular'] text-[15px] text-[#5b1ae4] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#5b1ae433] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#d8c7fb] border !rounded-3xl border-[#5b1ae433] !pb-8",
      titles: "text-[#5b1ae4] font-['PottaOneRegular'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#5b1ae4] font-['FigtreeRegular'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#5b1ae433]",
        sectionTitle:
          "text-[#99ACFE] font-['PottaOneRegular'] text-[30px] text-left leading-[100%] tracking-[-0.04em] [-webkit-text-stroke:7px_#5b1ae4] [paint-order:stroke_fill] pl-4 sm:pl-8 !mb-4 sm:mb-6 uppercase",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#d8c7fb]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative rounded-xl overflow-hidden",
          media: "w-full !aspect-square object-cover rounded-xl",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-xl",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#5b1ae4] font-['PottaOneRegular'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#5b1ae4] font-['FigtreeRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#5b1ae433]",
        sectionTitle:
          "text-[#99ACFE] font-['PottaOneRegular'] text-[30px] text-left leading-[100%] tracking-[-0.04em] [-webkit-text-stroke:7px_#5b1ae4] [paint-order:stroke_fill] pl-4 sm:pl-8 !mb-4 sm:mb-6 uppercase",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#d8c7fb]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative rounded-xl overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-xl",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-xl",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#5b1ae4] font-['PottaOneRegular'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#5b1ae4] font-['FigtreeRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#5b1ae4] font-['FigtreeRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#5b1ae4] font-['FigtreeRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#5b1ae4] font-['PottaOneRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#390f93] font-['FigtreeRegular'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#99ACFE] font-['PottaOneRegular'] text-[30px] text-left leading-[100%] tracking-[-0.04em] [-webkit-text-stroke:7px_#5b1ae4] [paint-order:stroke_fill] !mb-4 sm:mb-6 uppercase",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#d8c7fb] border border-[#5b1ae433] !rounded-3xl !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#5b1ae433]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-xl",
        title: "text-[#5b1ae4] font-['PottaOneRegular'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#5b1ae4] font-['FigtreeRegular'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#5b1ae4] border-2 border-[#5b1ae4] rounded-lg px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['PottaOneRegular'] !text-[16px] uppercase text-left leading-[120%]",
        questions: "text-[15px] text-left leading-[120%] text-[#5b1ae4]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#5b1ae433]",
        header: "text-[#5b1ae4] font-['PottaOneRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#390f93] font-['FigtreeRegular'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#5b1ae433]",
        header: "text-[#5b1ae4] font-['PottaOneRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#390f93] font-['FigtreeRegular'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden rounded-xl gap-y-[10px]",
        mapPinColor: "#5b1ae4",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#5b1ae4] font-['PottaOneRegular'] text-[24px] text-left leading-[110%]",
        text: "text-[#390f93] font-['FigtreeRegular'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#5b1ae4] font-['PottaOneRegular'] text-[26px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#d8c7fb]",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#d8c7fb] border border-[#390f93] rounded-lg px-3 py-3 text-[#5b1ae4] font-['PottaOneRegular'] text-[14px] uppercase text-left leading-[120%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#d8c7fb] border-b border-[#5b1ae433] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#5b1ae4] font-['PottaOneRegular'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#5b1ae4] font-['FigtreeRegular'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#5b1ae4] font-['PottaOneRegular'] text-[16px] text-left leading-[110%]",
          quantity:
            "text-[#5b1ae4] font-['PottaOneRegular'] text-[14px] uppercase text-left leading-[120%]",
          status: "text-[#5b1ae4] font-['PottaOneRegular'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#d8c7fb] border border-[#390f93] rounded-lg px-3 py-3 gap-x-4 !w-fit !h-10",
          button:
            "bg-[#d8c7fb] border border-[#390f93] rounded-lg px-3 py-3 text-[#5b1ae4] font-['PottaOneRegular'] text-[14px] uppercase text-left leading-[120%] !w-fit",
          plusMinusColor: "#390f93",
        },
      },
    },
  },
}

export default SAPPHICSPACE
